import { render, staticRenderFns } from "./officialCard.vue?vue&type=template&id=14189b84&scoped=true&"
import script from "./officialCard.vue?vue&type=script&lang=js&"
export * from "./officialCard.vue?vue&type=script&lang=js&"
import style0 from "./officialCard.vue?vue&type=style&index=0&id=14189b84&prod&lang=less&scoped=true&"
import style1 from "./officialCard.vue?vue&type=style&index=1&id=14189b84&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14189b84",
  null
  
)

export default component.exports